import React, { useEffect } from 'react'
import './index.less'
import { Checkbox, Form, List, Space, Typography } from 'antd'
import ExperEnv from '../ExperEnv'
import { StepEnum, UserType } from '.'
import Flex from '../Flex'
import { PlusCircleOutlined } from '@ant-design/icons'
import imagesvg from '../../assets/images/toolsImg/1.png'



type ContainerProps = {
    formData: any
    updatePort?: (type: 'update' | 'add', value?: any) => void// 更新端口
    portCreatorNum: number
    modal: string
    setCurrentDefault: (port: number) => void, //设置默认打开工具端口
    currentDefault: number       //默认打开工具端口
}

const Container: React.FC<ContainerProps> = (props) => {

    const { formData, updatePort, portCreatorNum, modal, currentDefault, setCurrentDefault } = props

    const form = Form.useFormInstance()

    useEffect(() => {
        form.setFieldsValue(formData)
    }, [formData])


    return (
        <Form.List name="ports" >
            {
                (fields, { add, remove }, { errors }) => {
                    const list = form.getFieldValue('ports') || []
                    return <>
                        <List
                            header={
                                <Flex gap={60} style={{ padding: '0 20px', width: '100%' }}>
                                    <span style={{ width: '28px' }}>图标</span>
                                    <span style={{ flex: '1 0 0' }}>端口名称</span>
                                    <span style={{ width: '80px' }}>操作</span>
                                    <span style={{ width: '56px' }}>是否启动</span>
                                    <span style={{ width: '56px' }}>默认打开</span>
                                </Flex>
                            }
                            dataSource={list}
                            style={{ borderBottom: '1px solid rgba(5, 5, 5, 0.06)', marginBottom: '20px' }}
                            renderItem={(item: any, index: number) => {
                                return <List.Item style={{ height: '48px' }}>
                                    <Flex gap={60} style={{ padding: '0 20px', width: '100%' }}>
                                        <div style={{ width: '28px' }}>
                                            <img style={{ width: '16px' }} src={item?.image ?? imagesvg} alt="" />
                                        </div>
                                        <span style={{ flex: '1 0 0', color: '#333333' }} className='os-ellipsis'>{item?.name}</span>
                                        <Space style={{ width: '80px' }} size={20}>
                                            <Typography.Link disabled={item?.port === 0 || !(modal === '1' ? item?.type === UserType.CREATOR : item?.type === UserType.LEARNER)} onClick={() => {
                                                updatePort?.('update', { ...item })
                                            }}>编辑</Typography.Link>
                                            <Typography.Link disabled={item?.port === 0 || !(modal === '1' ? item?.type === UserType.CREATOR : item?.type === UserType.LEARNER)} onClick={() => {
                                                form.setFieldValue('ports', list.filter((_: any, ind: number) => ind !== index))
                                            }}>删除</Typography.Link>
                                        </Space>
                                        <div style={{ width: '56px' }}>
                                            <Checkbox
                                                disabled={item?.port === 0 || !(modal === '1' ? item?.type === UserType.CREATOR : item?.type === UserType.LEARNER)}
                                                checked={item?.port === 0 || (item?.choice && (item.isUse || item.isUse === undefined))}
                                                onChange={(e) => {
                                                    form.setFieldValue(['ports', index, 'choice'], e.target.checked)
                                                    if (!e.target.checked && currentDefault != undefined && currentDefault === item?.port) {
                                                        setCurrentDefault(0)
                                                    }
                                                }} />
                                        </div>
                                        <div style={{ width: '56px' }}>
                                            <Checkbox
                                                disabled={modal !== '1' || (item?.port !== 0 && !(item?.choice && (item.isUse || item.isUse === undefined)))}
                                                checked={item?.port === currentDefault}
                                                onChange={(e) => {
                                                    if (!e.target.checked && currentDefault === item?.port) {
                                                        setCurrentDefault(-1)
                                                    } else {
                                                        setCurrentDefault(item?.port)
                                                    }
                                                }} />
                                        </div>
                                    </Flex>
                                </List.Item>
                            }}
                        />
                        <Typography.Link disabled={portCreatorNum >= 10} onClick={() => {
                            if (portCreatorNum < 10) {
                                updatePort?.('add')
                            }
                        }}><Space size={4}><PlusCircleOutlined />添加端口</Space></Typography.Link>
                    </>
                }
            }
        </Form.List>
    )
}

export default Container